import EditedTime from "@atoms/Time/EditedTime";
import UpdatedTime from "@atoms/Time/UpdatedTime";
import { cn } from "@util/helpers";

type CardTimeProps = {
  /** The time when the card was last published */
  updatedTime: string;
  /** The time when the card was last edited */
  editedTime: string;
  /** Optional additional styling for the created time */
  createdClassName?: string;
  /** Optional additional styling for the edited time */
  editedClassName?: string;
  /** Flag to indicate if the updated timestamp should be displayed */
  hasUpdatedTimestampDisplay?: boolean;
  /** Optional additional styling for the container */
  className?: string;
};

/**
 * CardTime component that renders the updated and edited times of a card.
 * It displays the updated time and, if available, the edited time.
 */
const CardTime = ({
  editedTime,
  updatedTime,
  createdClassName,
  editedClassName,
  hasUpdatedTimestampDisplay = false,
  className,
}: CardTimeProps): React.ReactElement => {
  const updatedOrEdited = hasUpdatedTimestampDisplay ? editedTime : updatedTime;

  return (
    <div data-testid="card-time-component" className={className}>
      {updatedTime ? (
        <UpdatedTime
          updated={updatedOrEdited}
          className={cn(createdClassName)}
        />
      ) : null}

      {editedTime && hasUpdatedTimestampDisplay ? (
        <>
          <span> </span>
          <EditedTime
            updated={updatedTime}
            edited={editedTime}
            className={cn(editedClassName)}
          />
        </>
      ) : null}
    </div>
  );
};

export default CardTime;
